export default __webpack_public_path__ + "static/dots-pattren-61ef0f72ff047c280438da288f3ae342.svg";